import i18n from 'modules/core/lib/i18n'

import { CARD_TYPE } from 'modules/expenses/lib/types'

export const getCardTypeLabel = (card_type: CARD_TYPE): string => {
  switch (card_type) {
    case 'physical':
      return i18n.t('expenses_v2.cards.type.physical')
    case 'virtual':
      return i18n.t('expenses_v2.cards.type.virtual')
    case 'single_use':
      return i18n.t('expenses_v2.cards.type.single_use')
    default:
      throw new Error(`Unsupported card type: ${card_type}`)
  }
}
